<template>
  <v-app>
    <v-row class="locale">
      <v-col>
        <switch-locale></switch-locale>
      </v-col>
    </v-row>
    <div class="login-header">
      <v-row>
        <v-col class="pt-5">
          <img src="@/assets/logo.svg" height="50" alt="logo" />
        </v-col>
      </v-row>
    </div>
    <div class="main">
      <div class="login-form">
        <div class="welcome-text">
          <p style="margin-bottom: 0px">
            {{$t('message.login.initMsg', { value: 'default' })}}
          </p>
        </div>

        <v-form ref="form" v-model="valid" lazy-validation>

          <v-text-field
            v-model="pw"
            :rules="pwRules"
            :label="$t('message.login.pw', { value: 'default' })"
            required
            type="password"
          ></v-text-field>

          <v-text-field
            v-model="pwc"
            :rules="pwcRules"
            label="password confirmation"
            required
            type="password"
          ></v-text-field>

          <v-btn
            :disabled="!valid"
            block
            :loading="loading"
            color="#00475A"
            class="mr-4"
            @click="validate"
          >
            Validate
          </v-btn>
        </v-form>
        <v-alert text dense :color="color"  border="left" v-show="alert" dismissible class="mt-5">
          {{message}}
        </v-alert>
      </div>
    </div>
  </v-app>
</template>

<script>
import SwitchLocale from "@/components/SwitchLocale";
import LoginService from "@/services/LoginService";

export default {
  name: "PasswordPage",

  data: () => ({
    valid: true,
    alert: false,
    color: "default",
    message:"",
    loading: false,
    pw: "",
    pwRules: [
      (value) => !!value || "password is required",
      (value) => (value && value.length >= 8) || "minimum 8 characters",
      (value) =>
        /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(value) ||
        "Password must contain at least lowercase letter, one number, a special character and one uppercase letter",
    ],
    pwc: "",
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        let payload = {
          token: this.$route.params.token,
          password: this.pw,
        };
        this.loading = true;
        LoginService.initAccountCustomer(payload)
          .then((response) => {
            if (response.status == 200) {
              this.loading = false;
              this.btncolor = "success";
              this.$router.push('/login')
            }

            if (response.status == 204) {
              this.loading = false
              this.alert = true
              this.color = "warning";
              this.message = this.$t('message.error.userNotFound', { value: 'default' })
            }
          })
          .catch(() => {
            this.loading = false
            this.alert = true
            this.color = "error";
            this.message = this.$t('message.login.NoToken', { value: 'default' })
          });
      }
    },
  },

  computed: {
    pwcRules() {
      return [
        (value) => !!value || "password confirmation is required",
        (value) =>
          value === this.pw || "The password confirmation does not match",
      ];
    },
  },

  components: {
    SwitchLocale,
  },
};
</script>

<style scoped>
.login-header {
  margin: 0px auto;
  background-color: #fff;
  display: inline-flex;
}

.locale {
  position: absolute;
  right: 20px;
  top: 9px;
  width: 110px;
}

.main {
  background: url("../assets/background-login.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}

.login-form {
  
  margin: 150px auto;
  padding: 42px 80px 60px 80px;
  background: #fff;
  display: block;
  width: 565px;
  height: auto;
}

.welcome-text {
  text-align: center;
  font: normal normal normal 1em Calibri;
  color: #00475a;
  margin: 0px;
}

.pp > .theme--light.v-icon {
  color: #00475a;
}

p {
  padding: 0px;
  margin: 0px;
}

.v-btn {
  color: #fff;
}

a {
  color: #7b766a;
}
</style>